// Room player lookup and identity helpers.

import { useCallback } from 'react';
import { useRoomMyPlayer } from './useRoomMyPlayer';
import { useRoomPlayers } from './useRoomPlayers';
import type { RoomPlayer } from '@airhead-games/shared/types';

interface UseRoomPlayerLookupReturn {
  getPlayer: (playerId: string) => RoomPlayer | undefined;
  isMyPlayer: (playerId: string) => boolean;
}

export function useRoomPlayerLookup(): UseRoomPlayerLookupReturn {
  const myPlayer = useRoomMyPlayer();
  const { players } = useRoomPlayers();

  const getPlayer = useCallback(
    (playerId: string): RoomPlayer | undefined => {
      return players.find((player) => player.playerId === playerId);
    },
    [players]
  );

  const isMyPlayer = useCallback(
    (playerId: string) => {
      return myPlayer?.playerId === playerId;
    },
    [myPlayer]
  );

  return {
    getPlayer,
    isMyPlayer,
  };
}
